<template>
    <div id="app">
        <PatientNotes :Mode="'Edit'" :Type="AppServiceID"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PatientNotes from '@/components/DPEBB/Administrator/PatientNotes.vue'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';

export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: {
        Card,
        CardBody,
        TileNote,
        PatientNotes
    },
    created: function() {
        this.AppServiceID = this.$store.getters.GetOpticalID;
        this.$emit('update:layout', LayoutDefault);
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID);
    },

}
</script>

<style>

</style>
